import * as React from 'react';

import {
    useGetEnrollmentForm,
    useSubmitEnrollmentForm,
    useGetInboxStatus,
} from '../../graphql/hooks';

import {BUSINESS_REGIONS_OF_OPERATION} from './consts';
import {EnrollmentFormBanner} from './enrollment-form-banner';
import {EnrollmentFormConnected} from './enrollment-form-connected';
import {getIsEnrollmentFormDisabled} from './helpers';

export const FORM_NAME = 'sms_enrollment_form';

export function EnrollmentForm() {
    const {inboxStatus, isLoading, refetch: refetchInboxStatus} = useGetInboxStatus();

    const {inboxEnrollmentForm, isLoading: isLoadingForm} = useGetEnrollmentForm();
    const [initialValues, setInitialValues] = React.useState({});

    const {submitEnrollmentForm} = useSubmitEnrollmentForm();
    const onSubmit = () => {
        return submitEnrollmentForm().then(() => {
            refetchInboxStatus();
        });
    };

    React.useEffect(() => {
        if (inboxEnrollmentForm) {
            const updatedInitialValues: Record<string, any> = {};

            inboxEnrollmentForm.values.forEach((value) => {
                if (value && value.name && value.value) {
                    if (value.name === 'REGION_OF_OPERATION') {
                        // For this field, we have to map thes saved comma separated string to the values
                        const regionValues = value.value
                            .split(',')
                            .map((region) =>
                                BUSINESS_REGIONS_OF_OPERATION.find((r) => r.value === region)
                            );

                        updatedInitialValues[value.name] = regionValues;
                    } else {
                        updatedInitialValues[value.name] = value.value;
                    }
                }
            });
            setInitialValues(updatedInitialValues);
        }
    }, [inboxEnrollmentForm]);

    return (
        <EnrollmentFormConnected
            onSubmit={onSubmit}
            initialValues={initialValues}
            // @ts-expect-error
            isLoading={isLoading || isLoadingForm}
            isDisabled={getIsEnrollmentFormDisabled(
                inboxStatus && inboxStatus.enrollmentFormStatus.status
            )}
            banner={
                <EnrollmentFormBanner
                    enrollmentFormStatus={inboxStatus && inboxStatus.enrollmentFormStatus}
                />
            }
        />
    );
}
